import { createAction } from '@reduxjs/toolkit';
import { Receipt } from '../../models/receipts.models';
import { featureKey } from '../../index';

export const receiptsFulfilled = createAction<Receipt[]>(featureKey + '/receiptsFulfilled');

export const loadReceipts = createAction(featureKey + '/loadReceipts');
